import { isScrolledIntoView } from './scrolled-into-view';

export const floating = {
    init: () => {
        const $ = jQuery;

        const cta = $('#floating-cta');

        if (cta.length === 0) {
            return false;
        }

        $(window).on('scroll', () => {
            if ( !$(cta).hasClass('animated') && isScrolledIntoView($(cta)) ) {
                $(cta).addClass('animated');
            }
        });
    }
}